import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'secondary';
  className?: string;
}
export function Button({
  children,
  href,
  variant = 'primary',
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-xl font-bold uppercase tracking-wider rounded-lg transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg';
  const variants = {
    primary: 'bg-gradient-to-r from-[#00b8ff] to-[#ff2e92] text-white hover:shadow-[0_0_30px_rgba(0,184,255,0.6)]',
    secondary: 'bg-zinc-800 text-white border border-zinc-700 hover:bg-zinc-700 hover:border-[#00b8ff]'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${className}`;
  if (href) {
    return <a href={href} className={combinedClassName} data-id="element-39">
        {children}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-40">
      {children}
    </button>;
}